<template>
  <Analytics />
  <LandingHeader />
  <router-view></router-view>
  <LandingFooter />
</template>

<script setup lang="ts">
import { Analytics } from "@vercel/analytics/vue";
import { onMounted } from "vue";
import AOS from "aos";
import LandingHeader from "./components/LandingHeader.vue";
import LandingFooter from "./components/LandingFooter.vue";

onMounted(() => {
  AOS.init({
    once: true,
    delay: 250,
    offset: 0,
  });

  window.scrollTo(0, 0);
});
</script>
